export const X_DATA_GRID_PRO =
  '2b96a37025b2246e59d92745c2b098ccT1JERVI6NDAzMzcsRVhQSVJZPTE2Nzk3MjE3MTkwMDAsS0VZVkVSU0lPTj0x';
